require('./brokerStocksSaleOrderSuccess.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @components
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');

// @constants
const { FIRST_STEP, DATE_FORMAT_ES, CHARGE_ACCOUNT_PREFIX } = require('constants/index');

const CLASS_NAME = 'broker-stocks-sale-order-success';
const RETURN_TO_CORPORATES_OPERATIONS_LINK = '/myprofile/broker/corporatesOperations';
const GO_TO_MY_WALLET_URL = '/myprofile/broker';

class BrokerStocksSaleOrderSuccess extends React.Component {
    constructor(props) {
        super(props);

        this.buildHeader = this.buildHeader.bind(this);
        this.buildField = this.buildField.bind(this);
        this.buildLeftColumnDetails = this.buildLeftColumnDetails.bind(this);
        this.buildRightColumnDetails = this.buildRightColumnDetails.bind(this);
        this.buildFooter = this.buildFooter.bind(this);
    }

    buildField(primaryText, secondaryText, description = <span>&nbsp;</span>, primaryTextInjectStrings = []) {
        return (
            <div className={`${CLASS_NAME}__details-field`}>
                <h5 className={`${CLASS_NAME}__details-primary-text`}>
                    <FormattedText
                        value={primaryText}
                        format="uppercase"
                        injectedStrings={primaryTextInjectStrings}
                    />
                </h5>
                <div className={`${CLASS_NAME}__details-secondary-text`}>
                    {secondaryText}
                </div>
                <div className={`${CLASS_NAME}__details-gray`}>
                    {description}
                </div>
            </div>
        );
    }

    buildFooter() {
        return (
            <div>
                <div className="wizard-success-step__separator" />
                <div className="wizard-success-step__foot-buttons text-right">
                    <span className={`${CLASS_NAME}__corporates-operations-button`}>
                        <OKButton
                            modifier="ghost"
                            to={RETURN_TO_CORPORATES_OPERATIONS_LINK}
                        >
                            <FormattedText
                                value="stocksSaleOrder-returnToCorporateOperations"
                            />
                        </OKButton>
                    </span>
                    <OKButton
                        modifier="secondary"
                        to={GO_TO_MY_WALLET_URL}
                    >
                        <FormattedText
                            value="stocksSaleOrder-goToMyWallet"
                        />
                    </OKButton>
                </div>
            </div>
        );
    }

    buildHeader() {
        const { immBrokerStocksSaleOrder } = this.props;
        const orderNumber = immBrokerStocksSaleOrder.get('orderNumber');
        const boxTitleValue = (
            <div>
                <span>
                    {formatText('stocksSaleOrder-successTitle')}
                </span>
                <div className="wizard-success-step__success-sub-message">
                    <FormattedText
                        value="stocksSaleOrder-successSubtitle"
                        injectedStrings={[orderNumber]}
                    />
                </div>
            </div>
        );

        return (
            <div className="wizard-success-step__highlight">
                <i className="wizard-success-step__success-icon" />
                <div className="wizard-success-step__messages">
                    <OKBoxTitle value={boxTitleValue}/>
                </div>
            </div>
        );
    }

    buildLeftColumnDetails() {
        const { immBrokerStocksSaleOrder } = this.props;
        const immOperation = immBrokerStocksSaleOrder.get('operation');
        const immContract = immBrokerStocksSaleOrder.get('contract');
        const immAssociatedAccount = immBrokerStocksSaleOrder.get('associatedAccount');
        const immBalance = immAssociatedAccount.get('balance');

        const contractNumber = CHARGE_ACCOUNT_PREFIX + immBrokerStocksSaleOrder.getIn(['contract', 'product']) + immContract.get('number');
        const owner = immBrokerStocksSaleOrder.get('owner');
        const associatedAccountNumber = immAssociatedAccount.get('number');
        const balanceAmount = immBalance.get('amount');
        const balanceCurrency = immBalance.get('currency');
        const value = immOperation.get('descriptionValue');
        const contract = immBrokerStocksSaleOrder.get('walletAccountType');

        const contractNumberText = (
            <FormattedText
                value="stocksSaleOrder-successContractNumber"
                injectedStrings={[contractNumber]}
            />
        );
        const contractOwnerText = (
            <FormattedText
                value="stocksSaleOrder-contractOwnerName"
                injectedStrings={[owner]}
            />
        );

        const associatedAccountText = (
            <FormattedText
                value="stocksSaleOrder-associatedAccountId"
                injectedStrings={[associatedAccountNumber]}
            />
        );
        const associatedAccountBalanceText = (
            <FormattedText
                value="stocksSaleOrder-associatedAccountBalanceAmount"
                injectedStrings={[balanceAmount, balanceCurrency]}
            />
        );

        const valueField = this.buildField('stocksSaleOrder-value', value);
        const contractField = this.buildField('stocksSaleOrder-contract', contract);

        return (
            <div className={`${CLASS_NAME}__details-section-left`}>
                {valueField}
                {contractField}
                <div className={`${CLASS_NAME}__details-gray`}>
                    <div className={`${CLASS_NAME}__details-field`}>
                        {contractNumberText}
                        <br />
                        {contractOwnerText}
                    </div>
                    <div>
                        {associatedAccountText}
                        <br />
                        {associatedAccountBalanceText}
                    </div>
                </div>
            </div>
        );
    }

    buildRightColumnDetails() {
        const { immBrokerStocksSaleOrder } = this.props;
        const immOperation = immBrokerStocksSaleOrder.get('operation');
        const endDate = immOperation.get('endDate');
        const parsedDate = DateHelper.buildFormattedDate(endDate, DATE_FORMAT_ES);
        const titlesAmount = immBrokerStocksSaleOrder.getIn(['steps', FIRST_STEP, 'titlesAmount']);
        const currency = immBrokerStocksSaleOrder.getIn(['associatedAccount', 'balance', 'currency']);
        const dateField = this.buildField('broker-rightsBuySidebarDeadlineLabel', parsedDate);
        const titlesAmountField = this.buildField('stocksSaleOrder-titlesAmount', titlesAmount, undefined, [currency]);

        return (
            <div className={`${CLASS_NAME}__details-section-right`}>
                {dateField}
                {titlesAmountField}
            </div>
        );
    }

    render() {
        return (
            <ContentBox>
                {this.buildHeader()}
                <div className={`row ${CLASS_NAME}__details-container`}>
                    <div className="col-xs-4">
                        {this.buildLeftColumnDetails()}
                    </div>
                    <div className="col-xs-8">
                        {this.buildRightColumnDetails()}
                    </div>
                </div>
                {this.buildFooter()}
            </ContentBox>
        );
    }
}

BrokerStocksSaleOrderSuccess.propTypes = {
    immBrokerStocksSaleOrder: PropTypes.object.isRequired
};

module.exports = BrokerStocksSaleOrderSuccess;
